import { capturePostHogEvent } from './posthogClient';

function safeCapture(eventName, properties) {
  try {
    capturePostHogEvent(eventName, properties);
  } catch {
    // Analytics must not break duplicate review flows.
  }
}

export function captureDuplicateReviewView(reviewId, breweryId) {
  safeCapture('engage-view-duplicate-review', { reviewId, breweryId });
}

export function captureDuplicateReviewBack(reviewId, breweryId) {
  safeCapture('engage-click-duplicate-review-back', { reviewId, breweryId });
}

export function captureDuplicateReviewPrevious(reviewId, breweryId) {
  safeCapture('engage-click-duplicate-review-previous', { reviewId, breweryId });
}

export function captureDuplicateReviewNext(reviewId, breweryId) {
  safeCapture('engage-click-duplicate-review-next', { reviewId, breweryId });
}

export function captureDuplicateReviewApply(reviewId, breweryId, selectedFields) {
  safeCapture('engage-click-duplicate-review-apply', {
    reviewId,
    breweryId,
    selectedFields,
  });
}

export function captureDuplicateReviewComplete(reviewId, breweryId) {
  safeCapture('engage-click-duplicate-review-complete', { reviewId, breweryId });
}

export function captureDuplicateReviewAddBeer(reviewId, breweryId) {
  safeCapture('engage-click-duplicate-review-add-beer', { reviewId, breweryId });
}

export function captureDuplicateReviewAutoAdvance(reviewId, breweryId) {
  safeCapture('engage-click-duplicate-review-auto-advance', { reviewId, breweryId });
}
